import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./AuthStore";
import appReducer from "./ApplicationStore";
import menuReducer from "./UserMenuStore";
import chatReducer from "./ThreadStore";
import adminMenuReducer from "./AdminMenuStore";
import adminInsightsReducer from "./AdminInsightsStore";
import adminRbacReducer from "./AdminRBACStore"
import adminUsersReducer from "./AdminUsersStore";
import adminDocumentReducer from "./AdminDocumentsStore";
import adminMasterSopsReducer from "./AdminMasterSOPStore";
import bulkUploadReducer from "./BulkUploadStore";
const defaultMiddlewareConfig = {
  serializableCheck: {
    ignoredPaths: ["user.muiTheme", "payload.breakpoints"],
  }
};

const store = configureStore({
  reducer: {
    adminmastersops: adminMasterSopsReducer,
    admindocuments: adminDocumentReducer,
    adminusers: adminUsersReducer,
    adminrbac: adminRbacReducer,
    admininsights: adminInsightsReducer,
    adminmenu: adminMenuReducer,
    chat: chatReducer,
    menu: menuReducer,
    user: authReducer,
    app: appReducer,
    bulkupload: bulkUploadReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(defaultMiddlewareConfig)
});

export default store;